
/**
 * Takes raw incoming data from the API and applies some extra sugar.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  payments  The payments data
 * @returns  {Object}  The transformed data
 * @public
 */
exports.transformData = function(language, payments) {
    payments.map(function(payment) {
        payment.id = payment.payment.id;

        return payment;
    });

    return payments;
};
